export const aggregatesSelector = ({ standardTemplates = {} } = {}) => standardTemplates.aggregates;
